import { createSelector } from '@reduxjs/toolkit';
import { getOrganizationId } from '../organization/getOrganizationId';
import { tasksNotDeleted } from './tasks-not-deleted';
import { singleUserVersion } from '../organization/singleUserVersion';
import { currentEmployeeUuid } from '../employees/current-employee-uuid';
import { getStartTaskInstances } from './get-start-task-instances';
import { mondayThisWeek } from '../calendar/monday-this-week';
import { functionsNotDeletedByUuid } from './functions-not-deleted-by-uuid';
import { employeeNamesByUuid } from '../employees/employee-names-by-uuid';
import { eventOccurrenceByTaskUuid } from '../events/event-occurrence-by-task-uuid';

export const startTasks = createSelector(
  getOrganizationId,
  tasksNotDeleted,
  singleUserVersion,
  functionsNotDeletedByUuid,
  currentEmployeeUuid,
  employeeNamesByUuid,
  eventOccurrenceByTaskUuid,
  mondayThisWeek,
  (
    organizationId,
    tasks,
    singleUser,
    functionByUuid,
    currentEmployeeUuid,
    employeeNameByUuid,
    eventByTask,
    mondayThisWeek,
  ) => {
    return getStartTaskInstances(
      organizationId,
      tasks,
      singleUser,
      functionByUuid,
      currentEmployeeUuid,
      employeeNameByUuid,
      eventByTask,
      mondayThisWeek,
    );
  },
);
